export const PageHeader = ({ label, title, description, testId }) => (
  <section className="bg-[#FAFAFA] border-b border-black/5" data-testid={testId}>
    <div className="max-w-7xl mx-auto px-6 py-20 md:py-24">
      {label && (
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#C87A38] mb-3 fade-up">{label}</p>
      )}
      <h1 className="text-4xl sm:text-5xl tracking-tight font-bold max-w-3xl fade-up" style={{ animationDelay: "80ms" }}>
        {title}
      </h1>
      {description && (
        <p className="mt-5 text-base md:text-lg text-[#525252] leading-relaxed max-w-2xl fade-up" style={{ animationDelay: "160ms" }}>
          {description}
        </p>
      )}
    </div>
  </section>
);
